import React, { useContext, useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import PoliticalPartyService from "../../services/PoliticalPartyService";
import { AppDB } from "../../App";
import { CandidateDBContext } from "./CandidateDBContext";
import LocalDelimitationNational from "../../componets/LocalDelimitationNational";
import EventService, { eventService } from "../../services/EventService";
import { candidateService } from "../../services/CandidateService";
import AddCandidateComponet from "./Componet/AddCandidateComponet";
import AddCandidateDialog from "./Componet/AddCandidateDialog";
import CandidateDetail from "./CandidateDetail";
import { PrintOut } from "../reports/PrintOut";
import { reportService } from "../../services/ReportService";
import ScreenLoader from "../../componets/ScreenLoader";

export const CandidateManagement = ({ isPoliticalParty }) => {
	var { setIsPoliticalCandidate } = useContext(AppDB);

	useEffect(() => {
		setIsPoliticalCandidate(isPoliticalParty);
	}, [isPoliticalParty]);

	var { permission, toast } = useContext(AppDB);
	var { selectedCandidate, setSelectedCanditate, isOnlyView, setIsOnlyView } = useContext(CandidateDBContext);

	var [candidates, setCandidates] = useState([]);
	var [showCandidateDialog, setShowCandidateDialog] = useState(false);

	var [loading, setLoading] = useState(true);
	var [refresh, setRefresh] = useState(true);
	var [showAddDialog, setShowAddDialog] = useState({
		show: false,
		voterRecord: null,
		idNumber: "",
		village: null,
		delimitationID: null,
		delimitationLevelID: 2,
		event: null
	});
	var [eventsMapping, setEventsMapping] = useState([]);
	var raw_delim = { delimitationID: "", delimitationLevelID: "" }
	const [delimitation, setDelimitation] = useState(raw_delim);

	var eventServices = new EventService();

	const [lazyState, setlazyState] = useState({
		first: 0,
		rows: 10,
		page: 0,
		search: ""
	});

	const onPageChange = (event) => {
		setlazyState(event);
	};

	useEffect(() => {
		eventService
			.getAllEvents({
				PageIndex: 1,
				PageSize: 100000,
				IsPoliticalPaty: true,
				ActiveOnly: true
			})
			.then((res) => {
				setEventsMapping(res);
				setLoading(false);
			});
	}, [refresh]);

	useEffect(() => {
		if (showAddDialog.event !== null) {
			var params = {
				pageIndex: 1,
				pageSize: 1000000,
				// search: "",
				eventID: showAddDialog.event.eventID,
				delimitationID: delimitation.delimitationID,
				delimitationLevelID: delimitation.delimitationLevelID
			};
			setCandidates([]);
			if (delimitation.delimitationLevelID <= 3) {
				setLoading(true);
				candidateService.getAll(params).then((res) => {
					setCandidates(res.candidates);
					setLoading(false);
				});
			}


		}
	}, [delimitation, refresh, showAddDialog.event]);


	const [selectedEvent, setselectedEvent] = useState(null);
	const [showReport, setshowReport] = useState(false);
	const handleDownloadReport = () => {
		var payload = {
			ReportID: 14,
			eventid: selectedEvent?.eventID,
			DelimitationLevelID: delimitation?.delimitationLevelID,
			DelimitationID: delimitation?.delimitationID
		};
		getReport(payload);
	};
	const [base64, setBase64] = useState(null);
	const [fetchReportLoader, setfetchReportLoader] = useState(false);
	const [showReportDialog, setReportShowDialog] = useState(false);
	const getReport = (data) => {
		console.log("Report Parameters:", data);
		setfetchReportLoader(true);
		reportService
			.getReport(data)
			.then((response) => {
				setfetchReportLoader(false);

				if (response?.success) {
					setshowReport(true);
					setBase64(response.data);
					toast.show({ severity: "success", summary: "", detail: response.message, life: 3000 });
				} else {
					toast.show({ severity: "error", summary: "Message", detail: "No data found", life: 3000 });
				}
			})
			.catch((err) => {
				console.log(err);
				setfetchReportLoader(false);
				return toast.show({ severity: "error", summary: "Message", detail: "Something went wrong.", life: 3000 });
			});
	};
	return (
		<>
			<ScreenLoader visible={fetchReportLoader} />
			<PrintOut base64={base64} setBase64={setBase64} showDialog={showReport} setShowDialog={setshowReport} />
			<CandidateDetail />
			<AddCandidateDialog
				isNational={showAddDialog?.event?.isNationalDelimitation}
				delimitation={delimitation}
				refresh={refresh}
				setRefresh={setRefresh}
				key={JSON.stringify(showCandidateDialog)}
				showCandidateDialog={showAddDialog}
				setShowCandidateDialog={setShowAddDialog}
			/>
			<div className="card  p-align-stretch vertical-container">
				<h5>Candidates</h5>
				<div className="card">
					<b>
						Select Event <span style={{ color: "red" }}>*</span>
					</b>
					{!isOnlyView && (
						<div className="grid ">
							<div className="md:col-9 col-12">
								<Dropdown
									className="w-full"
									value={showAddDialog.event}
									options={eventsMapping}
									optionLabel="name"
									onChange={(e) => {
										setShowAddDialog({ ...showAddDialog, event: e.value });
										setDelimitation(raw_delim)
										setselectedEvent(e.target.value);
									}}
								/>
							</div>
							<div className="md:col-3 col-12">
								<Button
									disabled={
										showAddDialog.event === null ||
											[null, undefined, ""].includes(delimitation.delimitationID) ||
											showAddDialog?.event?.isNationalDelimitation ? delimitation?.delimitationLevelID !== 2 : delimitation?.delimitationLevelID !== 3
									}
									label="Add Candidate"
									loading={loading}
									onClick={() => {
										setShowAddDialog({ ...showAddDialog, show: true });
									}}
									className="p-button-success mr-3 ml-2"
								/>
							</div>
						</div>
					)}

					<br />
					{showAddDialog.event !== null && (<LocalDelimitationNational
						key={JSON.stringify(showAddDialog?.event)}
						showFilter={false}
						grid={showAddDialog?.event?.isNationalDelimitation === false ? 4 : 3}
						isNational={showAddDialog?.event?.isNationalDelimitation}
						requiredLevel={2}
						includeElectorDivision={showAddDialog?.event?.isNationalDelimitation === false}
						includeVotingCentre={false}
						councilGridBlock={showAddDialog?.event?.isNationalDelimitation === false ? 3 : 6}
						isCandidate={true}
						politicalDelimitation={showAddDialog?.event}
						onChange={(delimitationID, delimitationLevelID, isLastLevel, constituency_name) => {
							console.log(delimitationID, delimitationLevelID)
							setShowAddDialog({ ...showAddDialog,delimitationLevelID:delimitationLevelID, delimitationID: delimitationID, constituency_name });
							setDelimitation({ delimitationID, delimitationLevelID });
						}}
						onFilter={(e) => {
							setDelimitation({ ...e });
						}}
					/>)}

					<div className="grid my-2">
						<Button
							disabled={selectedEvent === null}
							label="Print Candidates"
							loading={loading}
							onClick={() => {
								handleDownloadReport();
							}}
							className="p-button-primary mr-3 ml-2"
						/>
					</div>
				</div>

				<DataTable
					size="small"
					scrollable={true}
					value={candidates}
					dataKey="id"
					paginator
					rows={10}
					rowsPerPageOptions={[5, 10, 25]}
					className="datatable-responsive"
					currentPageReportTemplate="Showing {first} to {last} of {totalRecords} candidates"
					emptyMessage="No candidate found."
					// header={header}
					responsiveLayout="scroll"
					// selection={SelectedPoliticalParty}
					// onSelectionChange={(e) => setSelectedPoliticalParty(e.value)}
					resizableColumns
					columnResizeMode="expand"
					// filters={filters}
					filterDisplay="Name"
					globalFilterFields={["Name"]}
					loading={loading}
				>
					<Column field="registrationNumber" header="Registration Number" sortable></Column>
					<Column field="ballotName" header="Name" sortable></Column>
					<Column field="delimitation" header="Demarcation" sortable></Column>
					<Column
						field="delimitationName"
						header="Demarcation Name"
						body={(e) => `${e.delimitationCode}-${e.delimitationName}`}
						sortable
					></Column>
					<Column field="candidateType" header="Candidate Type" sortable></Column>
					<Column
						field="actions"
						header="Actions"
						body={(e) => (
							<>
								<Button
									style={{ textAlign: "center", width: "30px", height: "30px" }}
									icon={"pi pi-pencil"}
									className="p-button-primary p-button-rounded mr-2 "
									tooltip="Click to Edit"
									onClick={(a) => {
										setIsOnlyView(false);

										setLoading(true);
										eventService.GetEventByID(e.eventID).then((res) => {
											e.event = res;
											setSelectedCanditate(e);
											setLoading(false);
										});
									}}
								/>
								{/* <Button
									style={{
										textAlign: "center",
										width: "30px",
										height: "30px"
									}}
									icon={"pi pi-eye"}
									tooltipOptions={{ position: "top" }}
									className="p-button-primary p-button-rounded mr-2"
									tooltip="Click to View"
									onClick={(a) => {
										// setIsOnlyView(true);
										setSelectedCanditate(e);
									}}
								/> */}
								{parseInt(e.Status) == 1 ? (
									<Button
										onClick={(a) => {
											// deActivateHandler(e.PoliticalPartyID);
										}}
										style={{ textAlign: "center", width: "30px", height: "30px" }}
										icon={"pi pi-times"}
										className="p-button-danger p-button-rounded mr-2"
										tooltip="Click to De-Activate"
									/>
								) : (
									<Button
										disabled
										style={{ textAlign: "center", width: "30px", height: "30px" }}
										icon={"pi pi- pi-times"}
										className="p-button-danger p-button-rounded mr-2"
										tooltip="Click to Activate"
									/>
								)}
							</>
						)}
					></Column>
				</DataTable>
			</div>
		</>
	);
};
